import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "backdrop"]

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    this.boundHandleKeydown = this.handleKeydown.bind(this);

    // Close sidebar when clicking outside on mobile
    document.addEventListener('click', this.boundHandleClickOutside);

    // Close sidebar when pressing escape key
    document.addEventListener('keydown', this.boundHandleKeydown);
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickOutside);
    document.removeEventListener('keydown', this.boundHandleKeydown);
  }

  get hideClass() {
    return document.documentElement.dir === 'rtl' ? 'translate-x-full' : '-translate-x-full'
  }

  toggle() {
    this.menuTarget.classList.toggle(this.hideClass)
    this.backdropTarget.classList.toggle('hidden')
    this.backdropTarget.classList.toggle('opacity-50')
    document.body.classList.toggle('overflow-hidden')
  }

  close() {
    this.menuTarget.classList.add(this.hideClass)
    this.backdropTarget.classList.add('hidden')
    this.backdropTarget.classList.remove('opacity-50')
    document.body.classList.remove('overflow-hidden')
  }

  handleClickOutside(event) {
    // Only handle clicks on mobile (when backdrop is visible)
    if (!this.backdropTarget.classList.contains('hidden') &&
        !this.menuTarget.contains(event.target) &&
        !event.target.closest('[data-action*="sidebar#toggle"]')) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && !this.backdropTarget.classList.contains('hidden')) {
      this.close()
    }
  }
}